import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import React, { useEffect, useMemo } from 'react';
import { Amplify, Auth } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { resetAllState } from 'store/rootReducer';
import { Routes } from 'routes';
import { awsConfig, hasLoginAccess } from 'config';
import { componentStyleOverrides, defaultTheme } from 'theme';
import SplashScreen from 'components/Splash/Splash';
import * as Selectors from './selectors';
import * as Actions from './slice';
import NotificationLayout from './NotificationLayout';

const stateSelector = createStructuredSelector({
  // loading: Selectors.makeSelectLoading(),
  // userData: Selectors.makeSelectUserData(),
  error: Selectors.makeSelectError(),
  mode: Selectors.makeSelectThemeMode(),
  currentLocale: Selectors.makeSelectCurrentLocale(),
  isMenuOpen: Selectors.makeSelectIsMenuOpen()
});
const AppManagement = () => {
  const { mode, currentLocale, isMenuOpen } = useSelector(stateSelector);
  const dispatch = useDispatch();
  const { palette, ...rest } = defaultTheme;
  Amplify.configure(awsConfig);
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const isLoggedIn = hasLoginAccess(authStatus);
  const theme = useMemo(
    () =>
      createTheme({
        palette: { ...palette, mode },
        ...rest,
        direction: currentLocale === 'en' ? 'ltr' : 'rtl',
        components: {
          ...componentStyleOverrides
        }
      }),
    [mode, currentLocale, defaultTheme]
  );

  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin]
  });
  const cacheLtr = createCache({ key: 'muiltr', stylisPlugins: [prefixer] });

  useEffect(() => {
    if (isLoggedIn) {
      Auth.currentAuthenticatedUser()
        .then(() => {
          dispatch(Actions.fetchUser());
        })
        .catch(error => {
          dispatch(Actions.logout());
          resetAllState(dispatch);
        });
    }
  }, [isLoggedIn]);

  if (authStatus === 'configuring') return <SplashScreen />;

  return (
    <>
      <CacheProvider value={currentLocale === 'en' ? cacheLtr : cacheRtl}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes
            // layout={Layout}
            // isAuthenticated={isLoggedIn}
            layoutProps={{
              // dispatch: dispatch,
              mode,
              locale: currentLocale,
              // isAuthenticated: isLoggedIn,
              isMenuOpen
              // loading
            }}
          />
          <NotificationLayout />
        </ThemeProvider>
      </CacheProvider>
    </>
  );
};

export default AppManagement;
